import PinPadDialog from './PinPadDialog';

export default PinPadDialog;
